import React from 'react';
import { Line } from 'react-konva';

const leftTri = 4;
const rightTri = 8;
const centerTri = 6;
let heightTri = 3;
const strokeWidthAdd = .05;

const points = {
  'over': [
              leftTri, 0,
              rightTri, 0,
              centerTri, heightTri
            ],
  'under': [
              leftTri, 0,
              rightTri, 0,
              centerTri, -heightTri
            ]
}

export const Triangletip = ({
   left,
   top,
   onMouseEnter,
   onMouseLeave,
   strokeWidth,
   bubbleBodyHeight,
   bubbleBodyWidth,
   yCoord4Bubble,
   leftBubble,
   placementShownInToolTip,
  }) => {

  const adaptForPlacement = (placementShownInToolTip === 'over' ? bubbleBodyHeight: 0 );

  top += yCoord4Bubble + adaptForPlacement + .1;

  left += leftBubble;


  return ( placementShownInToolTip === 'under' ?
    <Line
      x={left}
      y={top}
      points={points[placementShownInToolTip]}
      fill={'white'}
      stroke={'gray'}
      strokeWidth={strokeWidth + strokeWidthAdd}
      closed={true}
      lineCap = {'block'}
      perfectDrawEnabled={false}
      listening={false}
    />
      :
    <Line
      x={left}
      y={top}
      points={points[placementShownInToolTip]}
      fill={'white'}
      stroke={'gray'}
      strokeWidth={strokeWidth + strokeWidthAdd}
      closed={true}
      lineCap = {'block'}
      shadowColor={'gray'}
      shadowBlur={.5}
      shadowOffset={{x : .5, y : .5}}
      shadowOpacity={0.5}
      perfectDrawEnabled={false}
      listening={false}
    />);
};

export const Trianglehide = ({ // a blank white strip across top of triangle so the pointer looks like part of the bubble
   left,
   top,
   onMouseEnter,
   onMouseLeave,
   strokeWidth,
   bubbleBodyHeight,
   bubbleBodyWidth,
   yCoord4Bubble,
   leftBubble,
   placementShownInToolTip,
   opacity,
   fill
  }) => {

  const adaptForPlacement = (placementShownInToolTip === 'over' ? bubbleBodyHeight: 0 );

  top += yCoord4Bubble + adaptForPlacement - (placementShownInToolTip === 'over' ? .5: -.5 );

  left += leftBubble;

  return <Line
    x={left}
    y={top}
    points={points[placementShownInToolTip]}
    fill={fill}
    stroke={fill}
    strokeWidth={strokeWidth + strokeWidthAdd}
    closed={true}
    lineCap = {'block'}
    perfectDrawEnabled={false}
    listening={false}
  />;
};
